import { IUser } from '~/utils/types'

export const checkIsSupervisorUp = (user: IUser): boolean => {
  if (!user.profile) return false
  if (user.profile === 'manager') return true
  if (user.profile === 'supervisor') return true
  return false
}
